import type {
  PaymentCheckoutReturnPlatform,
  PaymentCheckoutStartResponse,
  PaymentCheckoutStatusResponse,
  StripeConnectDashboardLinkResponse,
  StripeConnectOnboardingResponse,
  StripeConnectStatusResponse,
  StripePlanCheckoutKey,
  StripePlanCheckoutStartResponse,
  StripePlanPortalStartResponse,
} from "@/types/services/api-contracts";

import { callEdgeData } from "./_core/edge-call";
import { PAYMENT_FUNCTION_NAME } from "./_core/function-names";

export const paymentService = {
  async startCheckout(data: {
    booking_id?: string;
    payment_id?: string;
    correlation_id?: string;
    return_platform?: PaymentCheckoutReturnPlatform;
    payment_method?: "pix" | "card";
  }): Promise<PaymentCheckoutStartResponse> {
    return callEdgeData<PaymentCheckoutStartResponse>(PAYMENT_FUNCTION_NAME, "start-checkout", {
      body: data,
    });
  },

  async getCheckoutStatus(data: {
    booking_id?: string;
    payment_id?: string;
    session_id?: string;
    correlation_id?: string;
  }): Promise<PaymentCheckoutStatusResponse> {
    return callEdgeData<PaymentCheckoutStatusResponse>(PAYMENT_FUNCTION_NAME, "checkout-status", {
      body: data,
    });
  },

  async reconcile(data: {
    booking_id?: string;
    payment_id?: string;
    correlation_id?: string;
  }): Promise<PaymentCheckoutStatusResponse> {
    return callEdgeData<PaymentCheckoutStatusResponse>(PAYMENT_FUNCTION_NAME, "reconcile", {
      body: data,
    });
  },

  async getConnectStatus(venueId: string): Promise<StripeConnectStatusResponse> {
    return callEdgeData<StripeConnectStatusResponse>(PAYMENT_FUNCTION_NAME, "connect-status", {
      method: "GET",
      params: { venue_id: venueId },
    });
  },

  async startConnectOnboarding(data: {
    venue_id: string;
    correlation_id?: string;
  }): Promise<StripeConnectOnboardingResponse> {
    return callEdgeData<StripeConnectOnboardingResponse>(PAYMENT_FUNCTION_NAME, "connect-onboarding", {
      body: data,
    });
  },

  async startConnectDashboard(data: {
    venue_id: string;
    correlation_id?: string;
  }): Promise<StripeConnectDashboardLinkResponse> {
    return callEdgeData<StripeConnectDashboardLinkResponse>(PAYMENT_FUNCTION_NAME, "connect-dashboard-link", {
      body: data,
    });
  },

  async startPlanCheckout(data: {
    plan_key: StripePlanCheckoutKey;
    tenant_id?: string;
    correlation_id?: string;
    return_platform?: PaymentCheckoutReturnPlatform;
    payment_mode?: "subscription" | "pix_prepaid";
  }): Promise<StripePlanCheckoutStartResponse> {
    return callEdgeData<StripePlanCheckoutStartResponse>(PAYMENT_FUNCTION_NAME, "start-plan-checkout", {
      body: data,
    });
  },

  async startPlanPortal(data: {
    audience: "player" | "venue";
    tenant_id?: string;
    correlation_id?: string;
    return_platform?: PaymentCheckoutReturnPlatform;
  }): Promise<StripePlanPortalStartResponse> {
    return callEdgeData<StripePlanPortalStartResponse>(PAYMENT_FUNCTION_NAME, "start-plan-portal", {
      body: data,
    });
  },
};
